module.exports = __webpack_public_path__ + "static/media/RRC+-+JackjonPT+Website+-+iphone+8+.a8dc276e.png";